import React, { useContext } from "react";
import { ListActionButtonProps } from "sprint-common-web";

import { ViewAssetButton } from "../../../../../common/components/ViewAssetButton";
import { TvSeriesDashboardContext } from "../../../../TvSeriesDashboardProvider";
import { TvSeriesContext } from "../../../context/TvSeriesContext";

export const ViewEpisodeAssetButton: React.FunctionComponent<ListActionButtonProps> = (
    props: ListActionButtonProps
) => {
    const { moveToTvSeriesAssets } = useContext(TvSeriesContext);
    const { selectedSeason } = useContext(TvSeriesDashboardContext);

    const handleClick = () => {
        moveToTvSeriesAssets(selectedSeason?.id, props.itemId);
    };

    return <ViewAssetButton disabled={props.disabled} onClick={handleClick} />;
};
